import { Navigate, Route, Routes } from "react-router-dom";
import Customers from "./customers";
import Dashboard from "./dashboard";
import SalesForecastRoutes from "./forecast";
import Inventory from "./inventory";
import Orders from "./orders";
import SalesOrdersRoutes from "./ordersV2";
import PriceListRoutes from "./priceLists";
import Products from "./products";
import SalesReportRoutes from "./reports";

const SalesPages = () => {
  return (
    <Routes>
      <Route path="dashboard/*" element={<Dashboard />} />
      <Route path="products/*" element={<Products />} />
      <Route path="inventory/*" element={<Inventory />} />
      <Route path="customers/*" element={<Customers />} />
      <Route path="price-lists/*" element={<PriceListRoutes />} />
      <Route path="orders/*" element={<Orders />} />
      <Route path="orders-v2/*" element={<SalesOrdersRoutes />} />
      <Route path="reports/*" element={<SalesReportRoutes />} />
      <Route path="forecast/*" element={<SalesForecastRoutes />} />
      <Route path="*" element={<Navigate to="/sales/products" />} />
    </Routes>
  );
};

export default SalesPages;
